/**
 * Created by akirilyuk on 08/02/2017
 * View responsible for displaying service interruption notification on the create case view,
 * if there is any for the current accountId
 */
define(function (require) {
    "use strict";
    
    var LE = require("app");
    var ServiceStatusModel = require("connection-models/ticketTab/ServiceStatusModel");
    var Template = require("connection-templates/ticketTab/serviceIncidentView.tmpl");
    var Button = require("ui/button/Button");

    var ServiceIncidentView = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ServiceIncidentView = Marionette.ItemView.extend({
            template: Template,
            className: "service-incident-view",
            model: ServiceStatusModel,
            ui:{
                text: ".warning-text",
                link: ".warning-link"
            },
            
            uiComponents:{
                serviceHealthUrl:{
                    type:Button,
                    options:{
                        el: "view.ui.link",
                        permutation: Button.PERMUTATION.BLUELINK_TEXT_ALIGN,
                        text: LE.translator.translate("LEConnection.cases.createView.ServiceHealthUrl")
                    },
                    events:{
                        "click":"_onHealthStatusLinkClick"
                    }
                }
            },
            initialize: function (options) {
                this.container = options.el;
                this.model = new ServiceStatusModel();
                this.model.fetch();
                this._bindEvents();
            },

            _bindEvents: function(){
                this.listenTo(this.model,"sync",_.bind(this._evaluateHealthStatus,this));
            },

            onRender: function () {
                this.container.append(this.el);
                this.$el.addClass("hide");
            },

            _evaluateHealthStatus: function(){
                if(!this.model.isHealthy()){
                    this.$el.removeClass("hide");
                }
            },

            _onHealthStatusLinkClick: function(){
                var url = this.model.getHealthUrl();
                var win = window.open(url, '_blank');
                win.focus();
            }
        });
    });

    return ServiceIncidentView;


});
